import clsx from 'clsx';

import { textColorClasses } from '../classes/textColorClasses';
import type { Adaptive } from '../types/Adaptive';
import type { Color } from '../types/Color';

export function composeTextColorClasses(color: Adaptive<Color>): string {
    if (typeof color === 'object') {
        return clsx(
            color.base && textColorClasses[color.base],
            color.sm && `sm:${textColorClasses[color.sm]}`,
            color.md && `md:${textColorClasses[color.md]}`,
            color.lg && `lg:${textColorClasses[color.lg]}`,
            color.xl && `xl:${textColorClasses[color.xl]}`,
            color['2xl'] && `2xl:${textColorClasses[color['2xl']]}`
        );
    }

    return textColorClasses[color];
}
